import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91aff97c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "screen-reader-only" }, "Planfree.dev game lobby", -1))
const _hoisted_2 = {
  key: 3,
  class: "home"
}
const _hoisted_3 = { class: "top-buttons" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "#000000"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z" })
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div data-v-91aff97c>Invite players</div><div data-v-91aff97c><svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-91aff97c><path d=\"M9 12C9 13.3807 7.88071 14.5 6.5 14.5C5.11929 14.5 4 13.3807 4 12C4 10.6193 5.11929 9.5 6.5 9.5C7.88071 9.5 9 10.6193 9 12Z\" stroke=\"#1C274C\" stroke-width=\"1.5\" data-v-91aff97c></path><path d=\"M14 6.5L9 10\" stroke=\"#1C274C\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-91aff97c></path><path d=\"M14 17.5L9 14\" stroke=\"#1C274C\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-91aff97c></path><path d=\"M19 18.5C19 19.8807 17.8807 21 16.5 21C15.1193 21 14 19.8807 14 18.5C14 17.1193 15.1193 16 16.5 16C17.8807 16 19 17.1193 19 18.5Z\" stroke=\"#1C274C\" stroke-width=\"1.5\" data-v-91aff97c></path><path d=\"M19 5.5C19 6.88071 17.8807 8 16.5 8C15.1193 8 14 6.88071 14 5.5C14 4.11929 15.1193 3 16.5 3C17.8807 3 19 4.11929 19 5.5Z\" stroke=\"#1C274C\" stroke-width=\"1.5\" data-v-91aff97c></path></svg></div>", 2)
const _hoisted_7 = [
  _hoisted_5
]
const _hoisted_8 = {
  key: 1,
  class: "button invite copied no-hover"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, /*#__PURE__*/_toDisplayString(("copy_to_clip")), -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 -960 960 960",
  width: "24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h440l200 200v440q0 33-23.5 56.5T760-120H200Zm0-80h560v-400H600v-160H200v560Zm80-80h400v-80H280v80Zm0-320h200v-80H280v80Zm0 160h400v-80H280v80Zm-80-320v160-160 560-560Z" })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "top-left" }
const _hoisted_15 = {
  key: 0,
  class: "voting-on"
}
const _hoisted_16 = { class: "voting-on-label" }
const _hoisted_17 = {
  key: 0,
  class: "button no-hover"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cast your votes", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Show votes!", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 3,
  class: "button no-hover"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "name" }
const _hoisted_25 = {
  key: 4,
  class: "options"
}
const _hoisted_26 = ["onClick", "disabled"]
const _hoisted_27 = {
  key: 5,
  class: "results-container"
}
const _hoisted_28 = { class: "results" }
const _hoisted_29 = { class: "average" }
const _hoisted_30 = { class: "popular" }
const _hoisted_31 = { class: "tickets" }

import Modal from "@/components/Modal.vue";
import Player from "@/view-models/player";
import {io} from "socket.io-client";
import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import Tickets from "@/components/Tickets.vue";
import {useTickets} from "@/composables/useTickets";
import {useGameEngine} from "@/composables/useGameEngine";
import PFLittleButton from "@/components/LittleButton.vue";
import Settings from "../components/SettingsModal.vue";
import Sharing from "../components/SharingModal.vue";
import GameFormat from "@/view-models/gameFormat";


export default /*#__PURE__*/_defineComponent({
  __name: 'Game',
  setup(__props) {

let showInstallPwa = ref(false);
const modal = ref(true);
const settings = ref(false)
const showCopiedToClipboard = ref(false);
const name = ref("");
const showTickets = ref(false);
const {votingOnName, tickets} = useTickets();
const {
  socket,
  setSocket,
  players,
  showVotes,
  countdown,
  currentVote,
  gameFormat,
  closestValue,
  averageValue
} = useGameEngine();
const showShareModal = ref(false);

let deferredPrompt: any;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  showInstallPwa.value = true;
});

function saveSettings(gameType: GameFormat) {
  settings.value = false;
  socket.value.emit("gameTypeChanged", gameType);
}

async function dismissModal() {
  showShareModal.value = false;
}

function installPWA() {
  deferredPrompt.prompt();
}

onMounted(() => {
  if (joiningAGame()) {
    const route = useRoute();
    const newSocket = io(process.env.VUE_APP_SERVER, {
      query: {
        roomId: route.params.id,
      },
    });
    setSocket(newSocket);
  }

  const storedName = localStorage.getItem("name");
  if (storedName) {
    enteredName(storedName);
  }
});

const startGameMessage = computed(() => {
  if (!tickets.value || tickets.value.every(t => t.score)) {
    return 'Start new game!'
  } else {
    return 'Vote next issue!'
  }
});

function showVotesClicked() {
  socket.value.emit("show");
}

function performVote(vote: string) {
  socket.value.emit("vote", vote);
  currentVote.value = vote;
}

function startNewGame() {
  socket.value.emit("restart");
}

function emitName(name: string) {
  socket.value.emit("name", name);
}

function enteredName(updatedName: string) {
  name.value = updatedName;
  emitName(updatedName);
  localStorage.setItem("name", updatedName);
  modal.value = false;
}

function playerHasVoted() {
  return (
      players.value.filter((p: Player) => p.vote !== null && p.vote !== undefined).length > 0
  );
}

function copyToClipboard() {
  showShareModal.value = true;
}

function goToGithub() {
  open("https://github.com/LukeGarrigan/planfree.dev");
}

function joiningAGame() {
  const currentState = socket.value;
  return (
      currentState &&
      Object.keys(currentState).length === 0 &&
      currentState.constructor === Object
  );
}


const toggleTickets = () => showTickets.value = !showTickets.value;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (modal.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          title: "Choose your display name",
          onCompleted: enteredName
        }))
      : _createCommentVNode("", true),
    (settings.value)
      ? (_openBlock(), _createBlock(Settings, {
          key: 1,
          title: "Settings",
          onSaveSettings: saveSettings,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (settings.value = false))
        }))
      : _createCommentVNode("", true),
    (showShareModal.value)
      ? (_openBlock(), _createBlock(Sharing, {
          key: 2,
          title: "share_modal_title",
          subTitle: "share_modal_subtitle",
          onDismissModal: dismissModal
        }))
      : _createCommentVNode("", true),
    (!modal.value && !settings.value && !showShareModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "edit-name-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (modal.value = true))
            }, [
              _createElementVNode("div", null, _toDisplayString(name.value), 1),
              _hoisted_4
            ]),
            (!showCopiedToClipboard.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button invite",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (copyToClipboard()))
                }, _hoisted_7))
              : _createCommentVNode("", true),
            (!modal.value && showCopiedToClipboard.value)
              ? (_openBlock(), _createElementBlock("button", _hoisted_8, _hoisted_11))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "fib-button",
              onClick: toggleTickets
            }, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(PFLittleButton, {
              type: "github",
              "popover-text": "Open repo",
              onClicked: _cache[3] || (_cache[3] = ($event: any) => (goToGithub()))
            }),
            _createVNode(PFLittleButton, {
              type: "pwa",
              "popover-text": "Install as app",
              onClicked: _cache[4] || (_cache[4] = ($event: any) => (installPWA()))
            }),
            _createVNode(PFLittleButton, {
              type: "settings",
              "popover-text": "Settings",
              onClicked: _cache[5] || (_cache[5] = ()=>{settings.value = true;})
            }),
            (_unref(votingOnName))
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("p", _hoisted_16, [
                    _createTextVNode("Voting on: "),
                    _createElementVNode("b", null, _toDisplayString(_unref(votingOnName)), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (!playerHasVoted() && !_unref(showVotes))
            ? (_openBlock(), _createElementBlock("button", _hoisted_17, _hoisted_19))
            : _createCommentVNode("", true),
          (playerHasVoted() && !_unref(showVotes))
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (showVotesClicked()))
              }, _hoisted_21))
            : _createCommentVNode("", true),
          (_unref(showVotes) && _unref(countdown) === 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "button start",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (startNewGame()))
              }, [
                _createElementVNode("span", null, _toDisplayString(startGameMessage.value), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(showVotes) && _unref(countdown) > 0)
            ? (_openBlock(), _createElementBlock("button", _hoisted_22, [
                _createElementVNode("span", null, _toDisplayString(_unref(countdown)), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(players), (player) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "players",
              key: player.id
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["player", { voted: player.vote }])
              }, [
                (_unref(showVotes) && _unref(countdown) === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(player.vote), 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", null, _toDisplayString(player.name), 1)
              ])
            ]))
          }), 128)),
          (!_unref(showVotes) || (_unref(showVotes) && _unref(countdown) !== 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gameFormat)?.values, (vote) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: `vote-${vote}`,
                    class: _normalizeClass(["fib-button", { current: _unref(currentVote) === vote }]),
                    onClick: ($event: any) => (performVote(vote)),
                    disabled: _unref(currentVote) === vote || _unref(countdown) > 0
                  }, [
                    _createElementVNode("span", null, _toDisplayString(vote), 1)
                  ], 10, _hoisted_26))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_unref(showVotes) && _unref(countdown) === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, "Average: " + _toDisplayString(_unref(averageValue)), 1),
                  _createElementVNode("div", _hoisted_30, "Closest: " + _toDisplayString(_unref(closestValue)), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_31, [
            _createVNode(Tickets)
          ], 512), [
            [_vShow, showTickets.value]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})